import { gql } from '@apollo/client';

/**
{
  "search": {
    "membership": "EMPTY",
    "page": 1,
    "perPage": 10,
    "q": "",
  }
}
 */

export const ListNotifications = gql`
  query ListNotifications($search: SearchNotificationsInput!) {
    listNotifications(search: $search) {
      docs {
        _id
        message
        active
        title
        membership
        date
      }
      page
      limit
      totalDocs
      totalPages
    }
  }
`;

export const ListScheduledNotifications = gql`
  query ListScheduledNotifications($search: SearchScheduledNotificationsInput!) {
    listScheduledNotifications(search: $search) {
      docs {
        _id
        message
        active
        title
        membership
        date
        days
        notificationType
      }
      page
      limit
      totalDocs
      totalPages
    }
  }
`;
